import { FC, useRef } from 'react';

import { ImageWithFallbackProps } from './ImageWithFallback.types';

export const ImageWithFallback: FC<ImageWithFallbackProps> = ({
  imageSource,
  fallbackImageSource,
  alt,
  ...extraProps
}) => {
  const imageRef = useRef(null);
  const fallbackTriggeredRef = useRef<boolean>(false);

  const getImageUrlVisual = (): string => {
    if (!imageSource) {
      return fallbackImageSource;
    }
    return imageSource;
  };

  const handleOnError = (): void => {
    if (!fallbackTriggeredRef.current && !!imageRef.current) {
      fallbackTriggeredRef.current = true;
      const currentImageRef = imageRef.current as HTMLImageElement;
      currentImageRef.src = fallbackImageSource;
    }
  };

  return (
    <img
      src={getImageUrlVisual()}
      onError={handleOnError}
      ref={imageRef}
      alt={alt}
      {...extraProps}
    />
  );
};
